import { error } from "@workspace/common/src/assets/images";
import {
  CREATE_SELF_INTRO_MEDIA,
  CREATE_SELF_INTRO_MEDIA_SUCCESS,
  CREATE_SELF_INTRO_MEDIA_FAILURE,
  FETCH_SELF_INTRO_MEDIA,
  FETCH_SELF_INTRO_MEDIA_SUCCESS,
  FETCH_SELF_INTRO_MEDIA_FAILURE,
  DELETE_SELF_INTRO_MEDIA,
  DELETE_SELF_INTRO_MEDIA_SUCCESS,
  DELETE_SELF_INTRO_MEDIA_FAILURE,
  UPDATE_SELF_INTRO_MEDIA,
  UPDATE_SELF_INTRO_MEDIA_SUCCESS,
  UPDATE_SELF_INTRO_MEDIA_FAILURE,
  CREATE_PROJECT_MEDIA,
  CREATE_PROJECT_MEDIA_SUCCESS,
  CREATE_PROJECT_MEDIA_FAILURE,
  FETCH_PROJECT_MEDIA,
  FETCH_PROJECT_MEDIA_SUCCESS,
  FETCH_PROJECT_MEDIA_FAILURE,
  FETCH_PROJECT_MEDIA_LIST,
  FETCH_PROJECT_MEDIA_LIST_SUCCESS,
  FETCH_PROJECT_MEDIA_LIST_FAILURE,
  DELETE_PROJECT_MEDIA,
  DELETE_PROJECT_MEDIA_SUCCESS,
  DELETE_PROJECT_MEDIA_FAILURE,
  UPDATE_PROJECT_MEDIA,
  UPDATE_PROJECT_MEDIA_SUCCESS,
  UPDATE_PROJECT_MEDIA_FAILURE,
  FETCH_CANDIDATE_EDUCATION,
  FETCH_CANDIDATE_EDUCATION_SUCCESS,
  FETCH_CANDIDATE_EDUCATION_FAILURE,
  FETCH_CANDIDATE_WORK_EXPERIENCE,
  FETCH_CANDIDATE_WORK_EXPERIENCE_SUCCESS,
  FETCH_CANDIDATE_WORK_EXPERIENCE_FAILURE,
  FETCH_CANDIDATE_CERTIFICATIONS,
  FETCH_CANDIDATE_CERTIFICATIONS_SUCCESS,
  FETCH_CANDIDATE_CERTIFICATIONS_FAILURE,
  DELETE_CANDIDATE_CERTIFICATIONS,
  DELETE_CANDIDATE_CERTIFICATIONS_SUCCESS,
  DELETE_CANDIDATE_CERTIFICATIONS_FAILURE,
  DELETE_CANDIDATE_EDUCATION,
  DELETE_CANDIDATE_EDUCATION_SUCCESS,
  DELETE_CANDIDATE_EDUCATION_FAILURE,
  DELETE_CANDIDATE_WORK_EXPERIENCE,
  DELETE_CANDIDATE_WORK_EXPERIENCE_SUCCESS,
  DELETE_CANDIDATE_WORK_EXPERIENCE_FAILURE,
} from "./actionType";

const initialState = {
  loading: true,
  data: null,
  error: null,
  selfIntroMedia: {},
  projectMedia: {},
  projectMediaList: [],
  candidateEducation: [],
  candidateWorkExperience: [],
  candidateCertificates: [],
};

const PortfolioReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SELF_INTRO_MEDIA:
      return {
        ...state,
        loading: true,
      };

    case CREATE_SELF_INTRO_MEDIA_SUCCESS:
      return {
        ...state,
        loading: false,
        selfIntroMedia: action.payload,
      };

    case CREATE_SELF_INTRO_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_SELF_INTRO_MEDIA:
      return {
        ...state,
        loading: true,
      };

    case FETCH_SELF_INTRO_MEDIA_SUCCESS:
      return {
        ...state,
        loading: false,
        selfIntroMedia: action.payload,
      };

    case FETCH_SELF_INTRO_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SELF_INTRO_MEDIA:
      return {
        ...state,
        loading: true,
      };

    case DELETE_SELF_INTRO_MEDIA_SUCCESS:
      return {
        ...state,
        loading: false,
        selfIntroMedia: action.payload,
      };

    case DELETE_SELF_INTRO_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SELF_INTRO_MEDIA:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_SELF_INTRO_MEDIA_SUCCESS:
      return {
        ...state,
        loading: false,
        selfIntroMedia: action.payload,
      };

    case UPDATE_SELF_INTRO_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Project Media
    case CREATE_PROJECT_MEDIA:
      return {
        ...state,
        loading: true,
      };

    case CREATE_PROJECT_MEDIA_SUCCESS:
      const { workExperienceId, media } = action.payload;
      return {
        ...state,
        loading: false,
        projectMedia: {
          ...state.projectMedia,
          [media.workExperienceId]: media,
        },
      };

    case CREATE_PROJECT_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_PROJECT_MEDIA:
      return {
        ...state,
        loading: true,
      };

    case FETCH_PROJECT_MEDIA_SUCCESS:
      const { workExperienceId: fetchId, media: fetchedMedia } = action.payload;
      return {
        ...state,
        loading: false,
        projectMedia: {
          ...state.projectMedia,
          [fetchId]: fetchedMedia,
        },
      };

    case FETCH_PROJECT_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_PROJECT_MEDIA_LIST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_PROJECT_MEDIA_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        projectMediaList: action.payload,
      };

    case FETCH_PROJECT_MEDIA_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PROJECT_MEDIA:
      return {
        ...state,
        loading: true,
      };

    case DELETE_PROJECT_MEDIA_SUCCESS:
      const deletedId = action.payload.id;
      const projectMediaData = { ...state.projectMedia };
      const updatedProjectMedia = Object.keys(projectMediaData).reduce(
        (acc, key) => {
          if (projectMediaData[key].id === deletedId) {
            acc[key] = Object.keys(projectMediaData[key]).reduce(
              (obj, prop) => {
                obj[prop] = null;
                return obj;
              },
              {}
            );
          } else {
            acc[key] = projectMediaData[key];
          }
          return acc;
        },
        {}
      );
      return {
        ...state,
        loading: false,
        projectMedia: updatedProjectMedia,
      };

    case DELETE_PROJECT_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PROJECT_MEDIA:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PROJECT_MEDIA_SUCCESS:
      const { id: updatedId, updatedMedia } = action.payload;
      return {
        ...state,
        loading: false,
        projectMedia: {
          ...state.projectMedia,
          [updatedMedia.workExperienceId]: updatedMedia,
        },
      };

    case UPDATE_PROJECT_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_CANDIDATE_EDUCATION:
      return {
        ...state,
        loading: true,
      };

    case FETCH_CANDIDATE_EDUCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        candidateEducation: action.payload,
      };

    case FETCH_CANDIDATE_EDUCATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_CANDIDATE_WORK_EXPERIENCE:
      return {
        ...state,
        loading: true,
      };

    case FETCH_CANDIDATE_WORK_EXPERIENCE_SUCCESS:
      return {
        ...state,
        loading: false,
        candidateWorkExperience: action.payload,
      };

    case FETCH_CANDIDATE_WORK_EXPERIENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_CANDIDATE_CERTIFICATIONS:
      return {
        ...state,
        loading: true,
      };

    case FETCH_CANDIDATE_CERTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        candidateCertificates: action.payload,
      };

    case FETCH_CANDIDATE_CERTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CANDIDATE_CERTIFICATIONS:
      return {
        ...state,
        loading: true,
      };

    case DELETE_CANDIDATE_CERTIFICATIONS_SUCCESS:
      const updatedCert = state.candidateCertificates.filter(
        (cert) => cert.id !== action.payload.id
      );
      return {
        ...state,
        loading: false,
        candidateCertificates: updatedCert,
      };

    case DELETE_CANDIDATE_CERTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CANDIDATE_EDUCATION:
      return {
        ...state,
        loading: true,
      };

    case DELETE_CANDIDATE_EDUCATION_SUCCESS:
      const updatedEducation = state.candidateEducation.filter(
        (education) => education.id !== action.payload.id
      );
      return {
        ...state,
        loading: false,
        candidateEducation: updatedEducation,
      };

    case DELETE_CANDIDATE_EDUCATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CANDIDATE_WORK_EXPERIENCE:
      return {
        ...state,
        loading: false,
      };

    case DELETE_CANDIDATE_WORK_EXPERIENCE_SUCCESS:
      const updatedCandidateWorkExperience =
        state.candidateWorkExperience.filter(
          (workExperience) => workExperience.id !== action.payload.id
        );
      return {
        ...state,
        loading: false,
        error: false,
        candidateWorkExperience: updatedCandidateWorkExperience,
      };

    case DELETE_CANDIDATE_WORK_EXPERIENCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default PortfolioReducer;
